<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {

  },
  directives: {
    'scroll-animation': {
      mounted(el) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              el.classList.add('animate__animated', 'animate__fadeInUp');
              observer.unobserve(el);
            }
          });
        }, {
          threshold: 0.1
        });
        observer.observe(el);
      }
    }
  }
}
</script>

<style lang="scss">
#app {
  padding-top: 86px;

}

.el-main {
  padding: 0 !important;
}

[v-scroll-animation] {
  opacity: 0;
}

.animate__animated {
  opacity: 1;
  --animate-duration: 0.8s;
}

h2 .first {
  font-size: 18px;
  color: #333333;
  margin-top: 10px;
}

@media screen and (max-width: 600px) {
  h2 {
    font-size: 18px !important;
    padding-bottom: 10px !important;
    padding-top: 20px !important;

    .first {
      font-size: 12px !important;
    }
  }

  .el-menu {
    border-top: 2px solid #0042C8;
  }

  .el-icon-arrow-down:before {
    background-image: url('/src/assets/navbar.png') !important;
    background-size: 100% 100% !important;
    color: #0052D9 !important;
  }

  .el-menu-item.is-active {
    color: #0052D9 !important;
    font-weight: bold !important;
    font-size: 16px !important;
    background-color: none !important;
  }

  .el-menu-item:focus,
  .el-menu-item:hover {
    background-color: none !important;
  }

  .el-submenu__title:hover {
    background-color: none !important;
  }

  .el-menu-item,
  .el-submenu__title {
    height: 46px !important;
    font-size: 16px !important;
    line-height: 46px !important;
    border-bottom: 1px solid #D9D9D9;
  }

  .el-menu-item-group__title {
    display: none !important;
  }

  .el-menu-item-group .el-menu-item {
    font-size: 14px !important;
  }

  .el-submenu .el-menu-item {
    height: 34px !important;
    line-height: 34px !important;
    color: #333 !important;
    font-size: 16px;
    border: none !important;
  }
}
</style>
